import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiNotificationService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('notification/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('notification/list', data);
  }

  create(data: any) {
    return this._api.post('notification/create', data);
  }

  update(data: any) {
    return this._api.post('notification/update', data);
  }

  remove(id: number) {
    return this._api.post('notification/remove/id/' + id);
  }
}
